<template>
    <div>
        <div class="dispatching">
            <div class="bar">
                <h4>核心价值</h4>
                <ol class="cells">
                    <li class="cell">
                        <p>助力客户建立深入到全面乡镇网络的市场营销体系</p>
                    </li>
                    <li class="cell">
                        <p>为客户提供快速精准的配送服务，更受控、时效更有保障</p>
                    </li>
                    <li class="cell">
                        <p>基于行业特性的仓配集成解决方案为客户提供更专业的服务</p>
                    </li>
                    <li class="cell">
                        <p>全程可视IT系统能力确保供应链安全</p>
                    </li>
                </ol>
            </div>
            <div class="container">
                <div class="card">
                    <div class="dispatching-content">
                        <h4>广度</h4>
                        <p>全国拥有117个区域配送中心，2500+最后一公里网点，位居全国第一</p>
                    </div>
                    <div class="dispatching-img">
                        <img src="../../images/picture/qwzp_gd.png">
                    </div>
                </div>
                <div class="card">
                    <div class="dispatching-content left">
                        <h4>深度</h4>
                        <p>全面覆盖乡镇级市场，2875个县/区级城市，39862个乡镇，同时提供家电、家居送装一体服务</p>
                    </div>
                    <div class="dispatching-img">
                        <img src="../../images/picture/qwzp_sd.png">
                    </div>
                </div>
                <div class="card">
                    <div class="dispatching-content">
                        <h4>时效</h4>
                        <p>同城24H内、跨市(含时效乡镇)48H到达。</p>
                    </div>
                    <div class="dispatching-img">
                        <img src="../../images/picture/qwzp_sx.png">
                    </div>
                </div>
                <div class="card">
                    <div class="dispatching-content left">
                        <h4>行业解决方案</h4>
                        <p>针对泛家电、泛快消、电商(含B2B平台)等行业提供专业物流解决方案</p>
                    </div>
                    <div class="dispatching-img">
                        <img src="../../images/picture/qwzp_hyjjfa.png">
                    </div>
                </div>
                <div class="card">
                    <div class="dispatching-content">
                        <h4>增值服务</h4>
                        <p>提供货物险、短信提醒、贴码服务、库存风险透视等增值服务</p>
                    </div>
                    <div class="dispatching-img">
                        <img src="../../images/picture/qwzp_zzfw.png">
                    </div>
                </div>
                <div class="card">
                    <div class="dispatching-content left">
                        <h4>IT智能管理</h4>
                        <p>全链条覆盖信息化系统，数字化运营，全流程IT智能管理，实现全程可视， 打造智慧物流新体系</p>
                    </div>
                    <div class="dispatching-img">
                        <img src="../../images/picture/qwzp_itzngl.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="less">
.dispatching {
    padding-bottom: 1rem;
    .bar {
        .cells {
            display: flex;
            width: 12rem;
            margin: 0 auto;
            flex-wrap: wrap;
            justify-content: center;
        }
        h4 {
            font-size: 26px;
            margin: 0.5rem 0;
            text-align: center;
        }
    }
    .cell {
        height: 1rem;
        width: 45%;
        margin: 0.1rem;
        display: flex;
        align-items: center;
        padding-left: 0.2rem;
        box-shadow: 0 0 5px 3px #f5f5f5;
        p {
            color: #333333;
            width: 2rem;
            padding: 0 0.3rem;
            display: flex;
            flex: 8;
        }
        &:before {
            content: "1";
            display: inline-block;
            text-align: center;
            width: 0.5rem;
            height: 0.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            border: 1px solid #0094ff;
            color: #0094ff;
        }
        &:nth-child(2) {
            &:before {
                content: "2";
            }
        }
        &:nth-child(3) {
            &:before {
                content: "3";
            }
        }
        &:nth-child(4) {
            &:before {
                content: "4";
            }
        }
    }
    .card {
        width: 100%;
        height: 3.54rem;
        margin: 0.6rem 0;
        &:after {
            content: "";
            display: block;
            clear: both;
            visibility: 0;
            height: 0;
        }
        img {
            width: 5.42rem;
        }
    }
    .dispatching-content {
        padding: 0.65rem;
        min-width: 40%;
        float: right;
        &.left {
            float: left;
        }
        h4 {
            font-size: 30px;
            color: #333333;
            margin: 0.25rem 0;
        }
        p {
            line-height: 1.8em;
            color: #666666;
            margin-bottom: 0.23rem;
            max-width: 4.5rem;
        }
    }
}

@media screen and (min-width: 840px) and (max-width: 1079px) {
    .dispatching .dispatching-content h4 {
        font-size: 26px;
    }
}

@media screen and (min-width: 481px) and (max-width: 839px) {
    .dispatching .dispatching-content h4 {
        font-size: 22px;
    }
}

@media screen and (max-width: 480px) {
    .dispatching {
        padding-bottom: 0.3rem;
        .bar {
            h4 {
                font-size: 18px;
                margin: 0.2rem 0;
                text-align: center;
            }
            .cells {
                box-sizing: border-box;
                width: 100%;
                padding: 0 0.15rem;
                flex-wrap: wrap;
            }
        }
        .cell {
            width: 50%;
            height: auto;
            min-width: 50%;
            box-sizing: border-box;
            padding: 0.15rem 0;
            border: 1px solid #e6e6e6;
            border-left: none;
            border-top: none;
            display: block;
            margin: 0;
            box-shadow: 0 0;
            &:nth-child(2n) {
                border-right: 0 none;
            }
            &:before {
                content: "1";
                display: block;
                margin: 0 auto 0.15rem auto;
                text-align: center;
                width: 0.15rem;
                height: 0.15rem;
                border-radius: 50%;
                border: 1px solid #0094ff;
                color: #0094ff;
            }
            &:nth-child(2) {
                &:before {
                    content: "2";
                }
            }
            &:nth-child(3) {
                border-bottom: 0 none;
                &:before {
                    content: "3";
                }
            }
            &:nth-child(4) {
                border-bottom: 0 none;
                &:before {
                    content: "4";
                }
            }
            h4 {
                font-size: 18px;
                margin-top: 0.05rem;
            }
            p {
                width: auto;
                font-size: 12px;
                margin: 0 auto;
                padding: 0.1rem 0;
                text-align: left;
                padding: 0 0.05rem;
            }
        }
        .card {
            margin: 0;
            padding: 0.15rem 0.15rem 0;
            box-sizing: border-box;
            height: auto;
            text-align: center;
        }
        .dispatching-content {
            padding: 0;
            float: none;
            h4 {
                font-size: 16px;
                margin: 0.15rem 0 0.1rem 0;
                text-align: center;
            }
            p {
                font-size: 12px;
                max-width: 80%;
                margin: 0 auto;
            }
        }
    }
}
</style>
<script>
export default {
    metaInfo: {
        title: '安得智联-全网直配|落地配|城市配送',
        meta: [{                 // set meta
            name: 'keyWords',
            content: '安得智联全网直配,落地配,城市配送'
        },{                 // set meta
            name: 'description',
            content: '安得智联全网直配,落地配,助力客户建立深入到全面乡镇网络的市场营销体系,为客户提供快速精准的配送服务,更受控、时效更有保障.'
        }]
    },
    name: 'dispatching',
    components: {}
};
</script>